module.exports = __webpack_public_path__ + "static/media/snowy-5.3def7c9f.svg";